import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';

const BrokenHeartIconContainer = styled.div`
  margin: 0;
`;

type Props = {
  className?: string;
  title?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
  tabIndex?: 0 | -1;
  ref?: React.Ref<SVGElement>;
};

const BrokenHeartIcon = ({
  className,
  ariaHidden,
  ariaLabel,
  tabIndex,
}: Props) => {
  return (
    <svg
      className={className}
      aria-hidden={ariaHidden}
      role={ariaHidden ? undefined : 'img'}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      xmlSpace="preserve"
    >
      <defs>
        <style>
          {`
            .cls-1 {
              "display" : none;
            }

            .cls-1, .cls-2 {
              "fill" : #051f4d;
              "stroke-width" : 0px;
            }
        `}
        </style>
      </defs>
      <path
        id="Heart_empty"
        data-name="Heart empty"
        className="cls-1"
        d="M6.1,4.4c1.2,0,2.3.5,3.2,1.3l1.8,1.8,1,1,.9-1,1.7-1.8c1.4-1.4,3.4-1.7,5.2-.9.9.5,1.6,1.3,1.9,2.3.3,1,.3,2-.2,2.9-1.6,2.9-7.3,9.4-9.6,9.4S3.8,12.8,2.4,10.2c-.5-.9-.5-2-.2-2.9.3-1,1-1.9,1.9-2.3.6-.3,1.3-.5,2-.5M17.9,3.1c-1.5,0-3,.6-4.1,1.7l-1.7,1.8-1.8-1.8c-1.8-1.8-4.5-2.2-6.7-1.1C1,5.1,0,8.2,1.2,10.8c1.3,2.4,7.5,10.1,10.8,10.1s9.4-7.7,10.7-10.1c1.3-2.6.3-5.8-2.3-7.1-.8-.4-1.7-.6-2.6-.6"
      />
      <g>
        <path
          className="cls-2"
          d="M11.7,14.3l-2.5-.7c-.2,0-.4-.2-.5-.5,0-.2,0-.5,0-.7l2.7-6.5-1.1-1.1c-1.8-1.8-4.5-2.2-6.7-1.1C1,5.1,0,8.2,1.2,10.8c1.2,2.1,6.2,8.5,9.6,9.8l.9-6.3Z"
        />
        <path
          className="cls-2"
          d="M20.5,3.7c-2.2-1.1-4.9-.7-6.7,1.1l-1,1.1-.5,4.9,2.7.8c.2,0,.4.3.5.5,0,.2,0,.5,0,.7l-3.8,8.1c.1,0,.3,0,.4,0,3.3,0,9.4-7.7,10.7-10.1,1.3-2.6.3-5.8-2.3-7.1Z"
        />
      </g>
    </svg>
  );
};

export const SoldIcon = React.forwardRef<SVGElement, Props>(
  (props, forwardRef) => <BrokenHeartIconContainer><BrokenHeartIcon {...props} ref={forwardRef} /></BrokenHeartIconContainer>,
);
